import React, { createContext, useCallback, useContext, useState } from 'react'

interface IForgotEmailContextState {
  usuarioId?: number
  setUsuarioId: (usuarioId: number) => void
  code?: string
  setCode: (code: string) => void
}

const ForgotEmailContext = createContext<IForgotEmailContextState>(
  {} as IForgotEmailContextState,
)

export function useForgotEmail(): IForgotEmailContextState {
  const context = useContext(ForgotEmailContext)

  if (!context) {
    throw new Error('useForgotEmail must be used within an ForgotEmailProvider')
  }

  return context
}

export const ForgotEmailProvider: React.FC = ({ children }) => {
  const [usuarioId, setUsuarioId] = useState(null)
  const [code, setCode] = useState(null)

  const setForgotusuarioId = useCallback((value: number | null) => {
    setUsuarioId(value)
  }, [])

  const setForgotCode = useCallback((value: string) => {
    setCode(value)
  }, [])

  return (
    <ForgotEmailContext.Provider
      value={{
        usuarioId,
        setUsuarioId: setForgotusuarioId,
        code,
        setCode: setForgotCode,
      }}
    >
      {children}
    </ForgotEmailContext.Provider>
  )
}
